import {isArray} from "./util/type-utils.js";
import {find, children} from "@21torr/dune/dom/traverse.js";

export const ANIM_ELEMENT_SELECTOR = '[class*="_anim-"]';
export const ANIM_ACTIVE_CLASS = "_anim-active";

let watchedElements = [];
let observer;

/**
 * Mark all child elements to use a micro interaction
 *
 * @param {HTMLElement} container
 */
function markChildElements(container) {
    let animation = container.dataset.childAnimation;

    if (!animation) {
        return;
    }

    if (0 !== animation.indexOf("_anim-")) {
        animation = `_anim-${animation}`;
    }

    children(container).forEach(element => {
        element.classList.add(animation);
    });
}

/**
 *
 */
export function initMicroAnimation() {
    // mark child elements
    find(`[data-child-animation]`).forEach(markChildElements);

    const initialElements = find(ANIM_ELEMENT_SELECTOR);
    watchedElements = [].concat(watchedElements, initialElements);

    /**
     *
     * @param entries
     */
    const updateElement = (entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            // mark element as visible + remove from observer
            entry.target.classList.add(ANIM_ACTIVE_CLASS);
            observer.unobserve(entry.target);

        });
    };

    observer = new IntersectionObserver(updateElement, {
        rootMargin: '0px',
        threshold: 0
    });

    window.requestAnimationFrame(() => {
        watchedElements.forEach(element => observer.observe(element));
    });
}

/**
 * Alle uebergebenen Elemente wieder zum Observer hinzufuegen, damit diese beim Scrollen wieder animiert werden
 *
 * @param elements {Array} - Array von Elementen
 */
export function addElementsToWatch(...elements) {
    if (isArray(elements) && elements.length > 0) {
        elements.filter(element => !element.classList.contains(ANIM_ACTIVE_CLASS)).forEach(element => {
            window.requestAnimationFrame(() => {
                observer.observe(element);
            });
        });
    }
}

/**
 * Fur alle uebergebenen Elemente Animationen wieder aktivieren, so das diese erneut abgespielt werden
 *
 * @param elements {Array} - Array von Elementen
 */
export function resetAnimationsforElements(...elements) {
    if (isArray(elements) && elements.length > 0) {

        elements.forEach(element => {
            element.classList.remove(ANIM_ACTIVE_CLASS)
        });

        addElementsToWatch(...elements);
    }
}
